import IndexTable from "../../../components/IndexTable"
import { Page } from "../styles"


const AdminList = () => {
    return (
        <Page>
            <IndexTable
                caption='Administradores'
                request='admins'
            />
        </Page>
    )
}

export default AdminList